import {
  initialState,
  OrderHistoryUi,
} from '@/components/Order/OrderDetails/OrderHistory/OrderHistoryUi';
import { OrderDetailsResponse } from '@/data/api/model/orders/orderDetailsDto';
import { OrderEventsResponse } from '@/data/api/model/orders/orderEventsDto';
import { formatDate } from '@/utils/dateTime';

export function orderEventsResponseToOrderHistoryUi(
  orderEventsResponse: OrderEventsResponse,
  orderDetailsResponse?: OrderDetailsResponse
): OrderHistoryUi {
  if (!orderDetailsResponse) return initialState;
  const ret: OrderHistoryUi = {
    events: orderEventsResponse.data.map((item, index) => ({
      id: `event_${orderDetailsResponse.order_detail_id}_${index}`,
      title: item.event_description,
      subtitle: formatDate(item.event_date, { time: true }),
    })),
    orderNumber: orderDetailsResponse.order_detail_number,
  };
  return ret;
}
